// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2711%27 viewBox=%270 0 14 11%27 fill=%27none%27%3E%3Cpath d=%27M4.75012 8.12738L1.62262 4.99988L0.557617 6.05738L4.75012 10.2499L13.7501 1.24988L12.6926 0.192383L4.75012 8.12738Z%27 fill=%27%23297DAE%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO: Can we get rid of this? Only used in ClientButton, and I don't see a ClientButton with success role */
/* TODO: Only used for CientButton error role in a few spots - can we convert those to RwButton? */
@font-face {
  font-family: "Arvo";
  src: local("Arvo"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Arvo/Arvo-Regular.ttf");
}
@font-face {
  font-family: "Droid Sans";
  src: local("Droid Sans"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/droid-sans/DroidSans.ttf");
}
@font-face {
  font-family: "Droid Serif";
  src: local("Droid Serif"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/droid-serif/DroidSerif-Regular.ttf");
}
@font-face {
  font-family: "Libre Baskerville";
  src: local("Libre Baskerville"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Libre_Baskerville/LibreBaskerville-Regular.ttf");
}
@font-face {
  font-family: "Merriweather";
  src: local("Merriweather Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Merriweather/Merriweather-Regular.ttf");
}
@font-face {
  font-family: "Old Standard TT";
  src: local("Old Standard TT Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Old_Standard_TT/OldStandard-Regular.ttf");
}
@font-face {
  font-family: "Open Sans";
  src: local("Open Sans Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Open_Sans/OpenSans-Regular.ttf");
}
@font-face {
  font-family: "PT Sans";
  src: local("PT Sans"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/PT_Sans/PT_Sans-Web-Regular.ttf");
}
@font-face {
  font-family: "Roboto";
  src: local("Roboto"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Roboto/Roboto-Regular.ttf");
}
@font-face {
  font-family: "Ubuntu";
  src: local("Ubuntu Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Ubuntu/Ubuntu-Regular.ttf");
}
@font-face {
  font-family: "Vollkorn";
  src: local("Vollkorn Regular"), url("https://privatelabel-cdn-v1.dev.rwsystems.io/assets/fonts/Vollkorn/Vollkorn-Regular.ttf");
}
@media (max-width: 767px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }
}

@media (max-width: 767px) {
  .mobile table.v-table tr:nth-child(odd) {
    border-left: 2px solid #9e9d99;
  }
}

@media (max-width: 767px) {
  .mobile table.v-table tr:nth-child(even) {
    border-left: 2px solid #d1cfcb;
  }
}

@media (max-width: 767px) {
  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }
}

@media (max-width: 767px) {
  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
    flex-basis: 100%;
  }
}

@media (max-width: 767px) {
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}

@media (max-width: 599px) {
  .stepper-footer button {
    width: 100%;
  }
}
@media (max-width: 599px) {
  .stepper-footer button.go-back {
    margin-bottom: 12px;
    margin-right: 0;
  }
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 22px;
}

::-webkit-scrollbar-track {
  background: #e0e0e0;
  border-radius: 50px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.footerwrapper .v-btn, .breadcrumbwrapper .v-btn, .v-application .v-btn {
  color: #4d5965;
  font-weight: bold;
  text-transform: initial;
}

.v-application .v-radio.v-item--active .v-icon, .v-application .v-radio:not(.v-item--active) .v-icon {
  background: #fff;
  border: #d4dbe0 solid 1px;
  border-radius: 100%;
  color: transparent !important;
  content: "";
  width: 100%;
  height: 100%;
}

.mx-min-2 {
  margin-left: -8px;
  margin-right: -8px;
}

.full-height {
  height: 100%;
}

.full-width {
  width: 100%;
}

.mh-350 {
  min-height: 350px;
}

.mh-450 {
  min-height: 450px;
}

.bordered {
  border: 1px solid #d4dbe0;
}
.bordered.bordered-top-0 {
  border-top: 0;
}
.bordered.bordered-right-0 {
  border-right: 0;
}
.bordered.bordered-bottom-0 {
  border-bottom: 0;
}
.bordered.bordered-left-0 {
  border-left: 0;
}

.bordered-top {
  border-top: 1px solid #d4dbe0;
}

.bordered-right {
  border-right: 1px solid #d4dbe0;
}

.bordered-bottom {
  border-bottom: 1px solid #d4dbe0;
}

.bordered-left {
  border-left: 1px solid #d4dbe0;
}

.rounded {
  border-radius: 6px;
}

.line-height-normal {
  line-height: normal !important;
}

.v-application .v-application--wrap .display-4,
.v-application .v-application--wrap .display-3,
.v-application .v-application--wrap .display-2,
.v-application .v-application--wrap .display-1,
.v-application .v-application--wrap .headline,
.v-application .v-application--wrap .title,
.v-application .v-application--wrap .subtitle-1,
.v-application .v-application--wrap .subtitle-2,
.v-application .v-application--wrap .body-1,
.v-application .v-application--wrap .body-2,
.v-application .v-application--wrap .caption,
.v-application .v-application--wrap .overline {
  font-family: inherit !important;
}
.v-application .pagewrapper .title {
  font-size: 1.2em !important;
}
.v-application .theme--light.v-btn {
  color: #4d5965;
}
.v-application .theme--light.v-btn.underline-on-focus:focus {
  box-shadow: none;
}
.v-application .search-results-menu {
  background-color: #fff;
  max-height: 340px !important;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 12px;
  overflow-y: hidden;
}
.v-application .search-results-menu .v-list {
  overflow-y: auto;
  max-height: 316px;
  padding-top: 0;
  padding-bottom: 0;
}
.v-application .search-results-menu .v-list:focus {
  outline: none;
}
.v-application .v-dialog {
  border-radius: 5px;
}
.v-application .v-dialog .v-toolbar .v-toolbar__content {
  padding: 0;
}
.v-application .v-dialog .col {
  flex: 0 0 100%;
}
.v-application .v-dialog .col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
.v-application .v-data-table {
  background: transparent;
  color: #4d5965;
}
.v-application .v-data-table thead.v-data-table-header tr {
  background-color: #fff;
}
.v-application .v-data-table thead.v-data-table-header tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #fff;
}
.v-application .v-data-table thead.v-data-table-header tr:first-child th {
  color: #4d5965;
  font-size: 1em;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
}
.v-application .v-data-table thead.v-data-table-header tr:first-child th.active, .v-application .v-data-table thead.v-data-table-header tr:first-child th:hover {
  color: #4d5965;
}
.v-application .v-data-table thead.v-data-table-header tr:first-child th.active .v-icon, .v-application .v-data-table thead.v-data-table-header tr:first-child th:hover .v-icon {
  color: #4d5965;
}
.v-application .v-data-table th label {
  font-size: 1em;
  font-weight: bold;
}
.v-application .v-data-table th .v-text-field {
  padding-bottom: 14px;
}
.v-application .v-data-table tr:nth-of-type(odd) {
  background-color: #f9fafb;
}
.v-application .v-data-table tr:nth-of-type(odd):hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #f9fafb;
}
.v-application .v-data-table tr:nth-of-type(even) {
  background-color: #fff;
}
.v-application .v-data-table tr:nth-of-type(even):hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #fff;
}
.v-application .v-data-table tr.first-level-tr {
  background-color: #eff3f5;
}
.v-application .v-data-table tr.first-level-tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #eff3f5;
}
.v-application .v-data-table tr.second-level-tr {
  background-color: #e1e7e9;
}
.v-application .v-data-table tr.second-level-tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #e1e7e9;
}
.v-application .v-data-table tr td {
  white-space: nowrap;
  font-size: 1em;
  color: #4d5965;
}
.v-application .v-data-table tr td:first-child {
  width: 1%;
}
.v-application .v-data-table tr td .avatar {
  margin-right: 10px;
}
.v-application .v-data-table tr td.mobile-td {
  width: auto;
  white-space: normal;
}
.v-application .v-data-table tr td.mobile-td ul li {
  width: 100%;
}
.v-application .v-data-table .v-datatable__actions {
  color: #4d5965;
}
.v-application .v-data-table .v-datatable__actions .v-input__slot::before, .v-application .v-data-table .v-datatable__actions .v-input__slot::after {
  border-color: #4d5965;
}
.v-application .v-menu__content {
  border: #d4dbe0 solid 1px;
  border-radius: 8px;
  box-shadow: none;
  margin-top: 4px;
}
.v-application .v-menu__content.v-autocomplete__content {
  border-radius: 8px;
  box-shadow: none;
}
.v-application .v-menu__content .v-list-item .v-list-item__title {
  font-size: 1em;
  overflow: initial;
}
.v-application .v-menu__content .v-list-item.v-list-item--active::before {
  opacity: 0;
}
.v-application .v-menu__content .v-list-item.v-list-item--active .v-list-item__title {
  color: #297DAE;
}
.v-application .log-form .v-input__icon .v-icon {
  font-size: 16px;
}
.v-application .log-form .v-label {
  margin-left: -25px;
}
.v-application .log-form .v-input--has-state.error--text .v-label {
  animation: cubic-bezier(0.075, 0.82, 0.165, 1);
}
.v-application .rw-border {
  border-radius: 8px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.14), 0 1px 3px rgba(0, 0, 0, 0.2);
}
.v-application .v-input {
  font-size: 1em;
}
.v-application .v-input .v-label {
  color: #4d5965;
  height: 100%;
  line-height: 100%;
}
.v-application .v-input .v-text-field__details {
  min-height: auto;
  overflow: initial;
}
.v-application .v-input .v-text-field__details .v-messages {
  font-size: 1em;
  min-height: auto;
}
.v-application .v-tooltip__content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12), 0 0 2px rgba(0, 0, 0, 0.14), 0 1px 3px rgba(0, 0, 0, 0.2);
  color: #4d5965;
  font-size: 0.9em;
  line-height: 1.5em;
  max-width: 250px;
  padding: 10px;
  text-align: center;
  opacity: 1 !important;
  overflow-wrap: break-word;
}
.v-application .v-tooltip__content::before {
  border-left: transparent solid 7px;
  border-right: transparent solid 7px;
  border-top: #d4dbe0 solid 7px;
  bottom: -8px;
  content: "";
  display: inline-block;
  height: 7px;
  left: calc(50% - 7px);
  position: absolute;
  width: 14px;
}
.v-application .v-tooltip__content::after {
  border-left: transparent solid 6px;
  border-right: transparent solid 6px;
  border-top: #fff solid 6px;
  bottom: -7px;
  content: "";
  display: inline-block;
  height: 7px;
  left: calc(50% - 6px);
  position: absolute;
  width: 12px;
}
.v-application .v-tooltip__content.left-tooltip::before, .v-application .v-tooltip__content.left-tooltip::after {
  left: calc(100% - 3px);
  bottom: calc(50% - 5px);
  transform: rotate(270deg);
}
.v-application .v-tooltip__content.right-tooltip::before {
  left: -11px;
  bottom: calc(50% - 5px);
  transform: rotate(90deg);
}
.v-application .v-tooltip__content.right-tooltip::after {
  left: -9px;
  bottom: calc(50% - 5px);
  transform: rotate(90deg);
}
.v-application .v-btn {
  border-width: 2px;
}
.v-application .v-btn.primary, .v-application .v-btn.info {
  color: #fff;
}
.v-application .v-btn.primary.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #297DAE !important;
  color: #fff !important;
  opacity: 0.5;
}
.v-application .v-btn.black--text {
  color: #4d5965 !important;
}
.v-application .v-radio .v-input--selection-controls__input {
  height: 20px;
  width: 20px;
}
.v-application .v-radio .v-input--selection-controls__ripple {
  left: -12px;
  top: calc(50% - 22px);
  height: 30px;
  width: 30px;
}
.v-application .v-radio.v-item--active .v-icon::after {
  content: "";
  cursor: pointer;
  width: 50%;
  height: 50%;
  background: #297DAE;
  position: absolute;
  border-radius: 100%;
  opacity: 1;
  top: 25%;
  left: 25%;
}
.v-application .v-simple-checkbox .v-icon, .v-application .v-input--checkbox i.v-icon, .v-application .custom-header-checkbox.select-indeterminate .v-icon, .v-application .custom-header-checkbox.select-all .v-icon, .v-application .custom-header-checkbox.select-empty .v-icon {
  border: #d4dbe0 solid 1px;
  border-radius: 4px;
  color: transparent !important;
  margin: auto;
  height: 18px;
  width: 18px;
}
.v-application .v-simple-checkbox .v-icon.mdi-checkbox-marked:after, .v-application .v-input--checkbox.v-input--is-label-active .v-icon.v-icon:after, .v-application .custom-header-checkbox.select-all .v-icon:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 10px;
  opacity: 1;
}
.v-application .v-simple-checkbox .v-icon.mdi-minus-box:after, .v-application .v-input--checkbox.v-input--indeterminate .v-icon:after, .v-application .custom-header-checkbox.select-indeterminate .v-icon:after {
  background-color: #297DAE;
  border-radius: 2px;
  width: 50%;
  height: 50%;
  opacity: 1;
  top: 25%;
  left: 25%;
}
.v-application .custom-header-checkbox {
  text-align: center;
  width: 24px;
}
.v-application .v-input--checkbox.v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon {
  color: transparent !important;
  opacity: 0.8;
}
.v-application .v-input--checkbox.v-input--selection-controls.v-input--is-disabled:hover .v-input--selection-controls__ripple:before {
  color: transparent;
  cursor: default;
}
.v-application .v-input--checkbox.v-input--selection-controls.v-input--is-disabled .v-ripple__container {
  display: none;
}
.v-application .theme--light.v-btn.v-btn--disabled, .v-application .theme--light.v-btn.v-btn--disabled .v-icon {
  color: rgba(77, 89, 101, 0.26) !important;
}
.v-application .theme--light.v-select .v-select__selections {
  color: #4d5965;
}
.v-application .theme--light.v-select .v-select__selections input {
  font-size: 1em;
}
.v-application .theme--light.v-select.v-text-field--outline > .v-input__control > .v-input__slot {
  border: #d4dbe0 solid 1px;
}
.v-application .theme--light.v-input.v-text-field--outline > .v-input__control > .v-input__slot {
  border: #d4dbe0 solid 1px;
  font-size: 0.8em;
}
.v-application .theme--light.v-input:not(.v-input--is-disabled) input {
  color: #4d5965;
}
.v-application .theme--light.v-icon {
  color: #4d5965;
}
.v-application .theme--light.v-card {
  color: #4d5965;
}
.v-application .theme--light.v-card.v-card--outlined {
  border-color: #d4dbe0;
  border-radius: 8px;
}
.v-application .theme--light.v-card > .v-card__text {
  color: #4d5965;
  font-size: 1em;
}
.v-application .theme--light.v-sheet {
  color: #4d5965;
}
.v-application .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #8b939b;
}
.v-application .theme--light.v-divider {
  border-color: #d4dbe0;
}
.v-application .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #d4dbe0;
}
.v-application .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
  border-color: #297DAE;
}
.v-application .theme--light.v-text-field.v-input--is-disabled .v-input__slot:before {
  -o-border-image: none;
     border-image: none;
}
.v-application .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: inherit !important;
}
.v-application .theme--light .v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover fieldset {
  border-color: #297DAE;
}
.v-application .theme--light.v-text-field--outlined fieldset {
  border-color: #d4dbe0;
}
.v-application .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 34px;
}
.v-application .v-btn-toggle.v-btn-toggle--selected {
  box-shadow: none;
}
.v-application .v-btn-toggle .v-btn.v-btn {
  border: #d4dbe0 solid 1px;
  color: #a6acb2;
  font-weight: bold;
  height: 34px;
  min-width: 80px;
  opacity: 1;
  padding-left: 20px;
  padding-right: 20px;
  text-transform: capitalize;
}
.v-application .v-btn-toggle .v-btn.v-btn:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.v-application .v-btn-toggle .v-btn.v-btn:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.v-application .v-btn-toggle .v-btn.v-btn.badge-selected {
  color: #297DAE;
}
.v-application .v-btn-toggle .v-btn.v-btn.badge-unselected {
  color: #a6acb2;
}
.v-application .v-btn-toggle .v-btn.v-btn.v-btn--active {
  background-color: #297DAE;
  border: #297DAE;
  color: #fff;
}
.v-application .v-btn-toggle .v-btn--active:before,
.v-application .v-btn-toggle .v-btn:focus:before,
.v-application .v-btn-toggle .v-btn:hover:before {
  background-color: #fff;
}
.v-application .v-input--switch {
  margin-bottom: 0;
  margin-top: 0;
}
.v-application .v-input--switch.v-input--switch--inset.v-input--is-label-active .v-input--switch__track {
  background-color: #297DAE;
  opacity: 1;
}
.v-application .v-input--switch.v-input--switch--inset.v-input--is-label-active .v-input--switch__thumb {
  background-color: #fff;
}
.v-application .v-input--switch .v-input__slot {
  margin-bottom: 0;
}
.v-application .v-input--switch .v-messages {
  display: none;
}
.v-application .v-list .v-list-item__content {
  color: #4d5965;
}
.v-application .v-slider {
  margin-left: 0;
}
.v-application .rw-datepicker-input label {
  top: 10px;
}
.v-application .mobile table tr:nth-child(odd) > div {
  border-left: #757575 solid 2px;
}
.v-application .mobile table tr:nth-child(even) > div {
  border-left: #c7c7c7 solid 2px;
}
.v-application .bdr-line {
  border: #d4dbe0 solid 1px;
}
.v-application .stepper-footer .go-back {
  margin-right: 8px;
}

.appwrapper {
  background-color: #fff;
}

.breadcrumbwrapper {
  min-height: 96px;
  transition: all ease-out 0.5s;
}
.breadcrumbwrapper.shrink {
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
  padding-top: 12px;
  padding-bottom: 12px;
  min-height: 66px;
  z-index: -1;
}
.breadcrumbwrapper .v-btn.v-size--default {
  font-size: 1em;
}
.breadcrumbwrapper .v-breadcrumbs {
  padding: 0;
}
.breadcrumbwrapper .v-breadcrumbs li {
  font-size: 0.55em;
  font-weight: normal;
}
.breadcrumbwrapper .v-breadcrumbs a {
  color: #4d5965;
}
.breadcrumbwrapper .v-breadcrumbs .v-list__tile--link {
  padding: 0;
  height: auto;
  font-size: 0.6em;
}
.breadcrumbwrapper .v-breadcrumbs .v-list__tile--link a {
  color: #4d5965;
}
.breadcrumbwrapper .v-breadcrumbs .v-breadcrumbs__divider {
  padding: 0 3px;
}

.drawerwrapper .theme--light.v-list .v-list__group--active:after,
.drawerwrapper .theme--light.v-list .v-list__group--active:before {
  background: 0;
}
.drawerwrapper > .v-list {
  padding: 0;
}
.drawerwrapper .v-list .v-icon {
  color: inherit;
}

.pagewrapper {
  color: #4d5965;
}
.pagewrapper .theme--light.v-list .v-input,
.pagewrapper .theme--light.v-toolbar .v-input,
.pagewrapper .theme--light.v-tabs__bar .v-input {
  font-size: 1.1em;
}
.pagewrapper .v-tabs__div {
  text-transform: initial;
}
.pagewrapper .client-name {
  color: #297DAE;
  cursor: pointer;
}
.pagewrapper .hoverable:hover {
  text-decoration: underline;
}
.pagewrapper .customList {
  height: 400px;
  overflow: auto;
}
.pagewrapper .v-tabs .v-tabs-items .v-btn.v-size--default {
  font-size: 1em;
}
.pagewrapper .v-tabs .v-tabs__item:not(.v-tabs__item--active) {
  opacity: 1;
}
.pagewrapper .v-tabs .v-tab {
  text-transform: unset;
  font-weight: bold;
  min-width: auto;
  font-size: 1.1em;
}
.pagewrapper .v-tabs.primary-tab .v-tabs-bar {
  background-color: transparent;
}
.pagewrapper .v-tabs.primary-tab .v-tabs-bar .v-slide-group__wrapper {
  border-bottom: #d4dbe0 solid 1px;
}
.pagewrapper .v-tabs.primary-tab .v-tabs-bar .v-tabs-slider-wrapper {
  height: 8px !important;
}
.pagewrapper .v-tabs.primary-tab .v-tabs-bar .v-tab.v-tab--active {
  color: #4d5965;
}
.pagewrapper .v-tabs.alternative-tab .active-tab {
  color: #297DAE;
}
.pagewrapper .v-tabs.alternative-tab .v-tab {
  padding-top: 20px;
  padding-bottom: 20px;
}
.pagewrapper .v-tabs.alternative-tab .v-tab:first-child {
  padding-left: 0;
}
.pagewrapper .v-tabs.secondary-tab .v-tabs__container {
  border: #d4dbe0 solid 1px;
  border-radius: 4px;
  height: 34px;
}
.pagewrapper .v-tabs.secondary-tab .v-tabs__container .v-tabs__item {
  text-transform: initial;
  font-size: 1.1em;
}
.pagewrapper .v-tabs.secondary-tab .v-tabs__container .v-tabs__item.v-tabs__item--active {
  color: #297DAE;
}
.pagewrapper .v-tabs.secondary-tab .v-tabs__container .v-tabs__div:first-child .v-tabs__item {
  border-right: #d4dbe0 solid 1px;
}
.pagewrapper .vert-center {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.pagewrapper .v-item-group {
  height: auto;
}
.pagewrapper .v-item-group.v-tabs-items {
  background-color: transparent;
}
.pagewrapper .v-card {
  box-shadow: none;
  color: #4d5965;
}
.pagewrapper .v-card .v-toolbar .v-toolbar__title {
  font-size: 1.1em;
}
.pagewrapper .v-card .v-card__text {
  color: #4d5965;
  font-size: 1em !important;
}
.pagewrapper .v-card .v-card__text .v-list {
  padding: 0 10px;
}
.pagewrapper .v-card .v-card__text .v-list .v-list__tile {
  padding: 0;
}
.pagewrapper .v-card.v-sheet > .v-card__text {
  color: #4d5965;
}
.pagewrapper .v-text-field--outlined > .v-input__control > .v-input__slot {
  border: #d4dbe0 solid 1px;
  min-height: 36px;
}
.pagewrapper .v-text-field--outlined > .v-input__control .v-input__append-inner {
  margin-top: 6px;
}
.pagewrapper .v-text-field--outlined.v-text-field--single-line input {
  margin-top: 4px;
}
.pagewrapper .v-text-field--outlined fieldset {
  border: 0;
}
.pagewrapper .v-text-field--outlined.v-input--has-state fieldset,
.pagewrapper .v-text-field--outlined.v-input--is-focused fieldset {
  border: 0;
}
.pagewrapper .rw-search-bar {
  margin-top: 0;
  padding-top: 0;
}
.pagewrapper .rw-search-bar .v-input__control .v-input__slot {
  border: #d4dbe0 solid 1px;
}
.pagewrapper .rw-search-bar .v-input__control .v-input__slot:hover {
  border: #d4dbe0 solid 1px;
}
.pagewrapper .rw-search-bar .v-input__control .v-input__slot input {
  margin-top: 0;
  max-height: 100%;
  padding: 5px 0;
}
.pagewrapper .rw-search-bar .v-label {
  font-size: 1em;
  height: auto;
  top: auto;
}
.pagewrapper .rw-search-bar.v-input .v-input__append-inner {
  margin-top: 4px;
}
.pagewrapper .rw-search-bar.v-input .v-input__append-outer {
  margin-bottom: 0;
  margin-top: 0;
}
.pagewrapper .container .c_card_title {
  font-size: 1.1em !important;
}
.pagewrapper .container .v-card {
  color: #4d5965;
  background-color: transparent;
}
.pagewrapper .container .v-card .v-card__title {
  line-height: 100%;
  font-size: inherit;
}
.pagewrapper .container .v-card .v-tabs .v-tabs__wrapper {
  border-bottom: #d4dbe0 solid 1px;
}
.pagewrapper .container .v-card .v-tabs .v-btn-toggle .v-btn {
  font-weight: normal;
}
.pagewrapper .container .v-card .v-tabs .v-tabs__div .v-tabs__item {
  font-weight: 600;
  color: #a6acb2;
}
.pagewrapper .container .v-card .v-tabs .v-tabs__div .v-tabs__item--active {
  color: #297DAE;
}
.pagewrapper .container .v-card .v-tabs .v-btn-toggle .v-btn.badge-unselected {
  color: #4d5965;
}
.pagewrapper .container .v-card-border > .v-card {
  border: #d4dbe0 solid 1px;
  border-radius: 8px;
}
.pagewrapper .v-table__overflow {
  border-top: #d4dbe0 solid 1px;
}
.pagewrapper .vue-dropzone {
  border: #d4dbe0 dashed 1px;
  border-radius: 2px;
}
.pagewrapper .line-legend {
  display: inline-flex;
  height: 4px;
  position: relative;
  top: -2px;
  width: 30px;
}
.pagewrapper .line-legend span {
  display: flex;
  flex: 1;
  margin-right: 2px;
}
.pagewrapper .account-types {
  align-items: center;
  border: #d4dbe0 solid 1px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  flex: 1;
  position: relative;
}
.pagewrapper .account-types.account-selected {
  border-color: #297DAE;
}
.pagewrapper .account-types.account-selected .check-icon {
  position: absolute;
  right: 12px;
  top: 12px;
}

.footerwrapper .v-btn.v-size--default {
  font-size: 1em;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
